<template>
  <div>
    <v-row>
      <v-col>
        <upload-excel
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
        />
      </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-btn color="primary" small @click="actualizarPOD()">Actualizar POD</v-btn> -
            <v-btn color="info" small @click="limpiar()">Limpiar</v-btn>
        </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
        :items="tableData"
        :headers="headers"
        class="elevation-1"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="procesado">
      <v-col>
         <v-alert dense type="info">
          Se ha actualizado las POD de las guias importadas
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="procesado">
      <v-col>
        <v-simple-table>
            <thead>
              <tr>
                <th>Guía</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(guia, index) in guiasActualizadas" :key="index">
                <td>{{guia.guia_hija}}</td>
                <td>{{guia.estatus}}</td>
              </tr>
            </tbody>
          </v-simple-table>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <waiting :totalGuias="tableData.length" :currentGuia="currentGuia" :guiaCreada="guiaActualizada" />
    </v-overlay>
  </div>
</template>

<script>
import UploadExcel from "../components/UploadExcel.vue";
import Waiting from "../components/WaitingCreandoGuias.vue";
import apicon from '../plugins/apicon';
export default {
  created: function () {},
  components: {
    UploadExcel,
    Waiting,
  },
  data() {
    return {
      overlay: false,
      tableData: [],
      tableHeader: [],
      currentGuia: 1,
      guiaActualizada: null,
      headers: [
        { text: "Guia Hija", value: "guia_hija" },
        { text: "Recibido Por", value: "pod_nombre" },
        { text: "DNI", value: "pod_dni" },
        { text: "Fecha", value: "pod_fecha" },
        { text: "Hora", value: "pod_hora" },
      ],
      guiasActualizadas : [],
      procesado: false,
      sheetName: null,
      isCliente: 1
    };
  },
  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$swal("No se pueden subir archivos mayortes a 1MB");
      return false;
    },
    handleSuccess({ results, header, sheetName }) {
      this.tableData = results;
      this.tableHeader = header;
      this.sheetName = sheetName;
      this.procesado = false;
      this.guiasActualizadas = [];
      this.currentGuia = 1;
    },
    limpiar: function(){
      this.tableData = [];
      this.tableHeader = [];
      this.guiasActualizadas = [];
      this.procesado = false;
      this.currentGuia = 1;
    },
    actualizarPOD:async  function () {
      //Verificar si hay guias
      if(this.tableData.length == 0){
        this.$swal("No ha importado datos");
        return;
      }
      //verificar que se haya importado un archivo valido
      if(this.sheetName != 'actualizar_pod'){
        this.$swal("El tipo de archivo importado parece no ser valido 'actualizar_pod' - SheetName: " + this.sheetName);
        return;
      }
      this.overlay = true;
      for (var i = 0; i <= this.tableData.length - 1; i++) {
        //crear las piezas (solo una pieza)
          await apicon.updateDataApi(apicon.getApiBaseUrl() + 'compraslineaupdpod',this.tableData[i]).then((result) =>{
                this.guiaActualizada = this.tableData[i].guia_hija;
                this.guiasActualizadas.push({
                  guia_hija: this.tableData[i].guia_hija,
                  estatus: result.message
                });
                this.currentGuia ++;
          });
      }
      this.overlay = false
      this.tableData = [];
      this.procesado = true;
      this.currentGuia = 1;
    },
  },
  mounted:async function () {
      await apicon.setAuthHeaders();
      this.isCliente = localStorage.getItem('cliente')
  },
};
</script>

<style>
</style>
